export function resolveAuthAvatarUrl(source) {
  const normalized = String(source || '').trim()
  if (!normalized) return ''
  if (/^(data:|blob:|file:)/i.test(normalized)) return normalized
  return `/auth/avatar?src=${encodeURIComponent(normalized)}`
}

function buildDisplayName(user) {
  const explicit =
    user?.displayName ||
    user?.name ||
    [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() ||
    user?.email ||
    ''
  return String(explicit || '').trim()
}

export const authProfileAdapter = {
  getAvatarSource(user) {
    return String(
      user?.avatar_url ||
        user?.avatarUrl ||
        user?.photoURL ||
        user?.picture ||
        ''
    ).trim()
  },
  getDisplayName(user) {
    const value = buildDisplayName(user)
    return value || 'User'
  },
  getInitials(user) {
    const explicit = String(user?.initials || '').trim()
    if (explicit) return explicit
    const name = buildDisplayName(user)
    if (!name) return 'NA'
    return (
      name
        .split(/\s+/)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() || '')
        .join('') || 'NA'
    )
  },
  getRoleLabel(user) {
    if (!user || typeof user !== 'object') return 'Logged In'
    if (user.roleLabel) return String(user.roleLabel)
    if (user.role) return String(user.role)
    if (user.is_superuser || user.isSuperuser) return 'SuperUser'
    if (user.is_admin || user.isAdmin) return 'Admin'
    return 'Logged In'
  },
  resolveAvatarUrl(source) {
    return resolveAuthAvatarUrl(source)
  },
}
